<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dcqkoE/tc-custom/9781429984287.jpg?1731797235246" alt="This image is the cover for the book Where Armadillos Go to Die, Jeremiah Spur Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Where Armadillos Go to Die, Jeremiah Spur Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p>Sylvester Bradshaw owns the Bouree restaurant, home of the best catfish within a hundred miles of Brenham, Texas. Besides being known for his cooking and for being one of the town's nastiest residents, he also happens to have invented a machine that several venture capitalists and one former NFL star would like to invest in at almost any cost. But Bradshaw---stubborn and miserly---can't be enticed no matter what offer they put on the table. Nobody gets a look and nobody gets to know how the device works, not even his family.<br/><br/>When the restaurant is ransacked and he goes missing, the only person willing to take his disappearance seriously is Jeremiah Spur. The retired Texas Ranger and rancher is a dedicated customer, if not a friend, which makes him the only man on whom the Bradshaws can pin their hopes.<br/><br/>James Hime's <i>Where Armadillos Go to Die</i> eloquently captures the voice and spirit of a small Texas town with troubles every bit as big as the whole state, making for some of the most engaging crime fiction on bookshelves today.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James Hime
      </h2>
      
      <p class="authorDescription body article"><P>James Hime's electrifying debut, <I>The Night of the Dance</I>, was a finalist for the Edgar Award for best first novel. Born in Arkansas, he lives in Dallas, Texas, with his wife and their golden retriever. <I>Where Armadillos Go to Die</I> is his third novel.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?fe872736